import Installments from './Installments';

export default Installments;
